import axios from "axios";
import {rndId} from './util';

class ApiClass {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }

    url(endpoint) {
        return this.baseUrl+'/'+endpoint;
    }

    async initQuiz({ email, firstName, lastName, phone, quizName, quizId, linkedIn, github, portalUrl, $Headhunter }) {
        let result = await axios.post(this.url('initquiz'), {
            email,
            firstName,
            lastName,
            phone,
            quizName,
            quizId,
            linkedIn,
            github,
            portalUrl,
            $Headhunter
        });

        return result.data;
    }

    async answer({takenQuizId, questionId, textAnswer, choiceAnswers, recordingId}) {
        let result = await axios.post(this.url('answer'), {
            takenQuizId,
            questionId,
            textAnswer,
            choiceAnswers,
            recordingId
        });

        return result.data;
    }

    async finish(takenQuizId) {
        let result = await axios.post(this.url('finish'), {
            takenQuizId
        });

        return result.data;
    }

    async cacheRecording(blob, id = null) {
        const recordingId = id ? id : rndId();
        const fd = new FormData();
        fd.append('upl', blob, recordingId);
        fd.append('upl_id', recordingId);

        await axios.post(this.url('cacherecording'), fd, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });

        return id;
    }
}


export default ApiClass;